import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  addPersonToSeat,
  fetchChart,
  setActiveSeatInput,
  updateGuestListAction,
  updateSeats,
  loadGuestList,
  removeSeatFromTable,
  updateGuestList,
} from '../../../../../actions/SeatingChartActions';
import { showModal } from '../../../../../actions/ModalActions';

import GuestResults from './GuestResults';

const SeatInput = ({
  clearSeat,
  groupingNames,
  guestSet,
  onAddGuestGroup,
  onUpdateSeats,
  seatUUID,
  seatsByUUID,
  setActiveForm,
  onAddPersonToSeat,
  flowRunId,
  updateFlowRunId,
}) => {
  // state
  const [searchString, updateSearchString] = useState('');
  const [hasFocus, updateHasFocus] = useState(false);

  // event handlers
  const handleFocus = () => {
    updateHasFocus(true);
    setActiveForm(seatUUID);
  };
  const handleBlur = () => {
    if (searchString === '') {
      updateHasFocus(false);
      setActiveForm(null);
    }
    return false;
  };
  const handleChange = e => {
    updateSearchString(e.target.value);
  };
  const handleGuestSelect = (guestID, name) => {
    const oldSeatUUID = guestSet[guestID].seatUUID;
    const newSeat = {
      ...seatsByUUID[seatUUID],
      guest_id: typeof guestID === 'number' ? guestID : null,
      couple_role: typeof guestID === 'string' ? guestID : null,
      display_name: name,
      isEmpty: false,
    };
    if (oldSeatUUID !== null) clearSeat(oldSeatUUID);
    onAddPersonToSeat(newSeat);
    onUpdateSeats();
    setActiveForm(null);
  };

  // logic + variables
  const placeholder = hasFocus ? 'Search Guests' : 'Click to Add Guest';
  const className = hasFocus ? 'sc__seat active' : 'sc__seat';

  return (
    <div className={className}>
      {hasFocus && (
        <i className="search-input__mag-icon zola-ui-icon-magnifying-glass" aria-hidden="true" />
      )}
      <input
        className="sc__seat-input"
        type="text"
        value={searchString}
        placeholder={placeholder}
        onChange={e => handleChange(e)}
        onBlur={() => handleBlur()}
        onFocus={() => handleFocus()}
      />
      {searchString !== '' && (
        <GuestResults
          guests={guestSet}
          groupNames={groupingNames}
          guestSelect={handleGuestSelect}
          onAddGuestGroup={() => onAddGuestGroup(flowRunId, updateFlowRunId)}
          token={searchString}
        />
      )}
    </div>
  );
};

SeatInput.propTypes = {
  guestSet: PropTypes.objectOf(
    PropTypes.shape({
      affiliation: PropTypes.string,
      displayName: PropTypes.string,
      groupID: PropTypes.number,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      seatUUID: PropTypes.string,
      tableUUID: PropTypes.string,
    })
  ),
  groupingNames: PropTypes.shape({
    WEDDING_COUPLE: PropTypes.string,
    PRIMARY_FAMILY: PropTypes.string,
    PARTNER_FAMILY: PropTypes.string,
    PRIMARY_FRIEND: PropTypes.string,
    PARTNER_FRIEND: PropTypes.string,
    PRIMARY_WEDDING_PARTY: PropTypes.string,
    PARTNER_WEDDING_PARTY: PropTypes.string,
    PRIMARY_FAMILY_FRIEND: PropTypes.string,
    PARTNER_FAMILY_FRIEND: PropTypes.string,
    BOTH: PropTypes.string,
    UNKNOWN: PropTypes.string,
  }),
  seatUUID: PropTypes.string,
  setActiveForm: PropTypes.func,
  onUpdateSeats: PropTypes.func,
  flowRunId: PropTypes.string,
  updateFlowRunId: PropTypes.func,
};

const mapStateToProps = state => ({
  groupingNames: state.guestRail.groupingNames,
  guestSet: state.seatingChart.guestSearchSet,
  seatsByUUID: state.seatingChart.seatsByUUID,
});

const mapDispatchToProps = dispatch => ({
  clearSeat: seat => dispatch(removeSeatFromTable(seat)),
  setActiveForm: seatUUID => dispatch(setActiveSeatInput(seatUUID)),
  onAddPersonToSeat: seat => dispatch(addPersonToSeat(seat)),
  onUpdateGuestList: () => dispatch(updateGuestListAction()),
  onLoadGuestList: () => dispatch(loadGuestList()),
  onUpdateSeats: () => dispatch(updateSeats()),
  directlyUpdateGuestList: updatedSeats => dispatch(updateGuestList(updatedSeats)),
  onAddGuestGroup: (flowRunId, updateFlowRunId) =>
    dispatch(
      showModal('ADD_GUEST_GROUP', {
        callback: () => dispatch(fetchChart(null)),
        guestGroupType: null,
        sendLinkVisible: false,
        formIdentifier: 'addGuestGroupForm',
        flowRunId,
        updateFlowRunId,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SeatInput);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Tables/Seat/SeatInput.jsx